import { CANCELLED } from "dns";

// src/app/constants.ts
export const DELIVERY_TYPES = [
    { label: 'NDP (Intracity)', value: '2' },
    { label: 'NDP (Intercity)', value: '3' },
    { label: 'DD (Intracity)', value: '1.5' },
    { label: 'DD (Intercity)', value: '2.5' },
    { label: 'DP By Buyer', value: '2' },
    { label: 'DP By Supplier', value: '0' }
  ];

  export const PAYMENT_TERMS = [
    { numberOfDays: '7', value: 0.34 },
    { numberOfDays: '15', value: 0.74 },
    { numberOfDays: '30', value: 1.48 },
    { numberOfDays: '40', value: 1.97 },
    { numberOfDays: '45', value: 2.22 },
    { numberOfDays: '60', value:  2.96}
  ];


export const AUCTION_STAGE = {
  ALL : -1,
  DRAFT : 0,
  SCHEDULED : 1,
  LIVE : 2,
  COMPLETED: 3,
  CANCELLED : 4
}

export const AUCTION_STAGE_LABELS: { [key: number]: string } = {
  [-1]: 'All',
  0: 'Draft',
  1: 'Scheduled',
  2: 'Live',
  3: 'Completed',
  4: 'Cancelled'
};

export const USER_ROLES = [
  { role: 'buyer', roleId: 2 },
  { role: 'supplier', roleId: 1 },
];

export const AUCTION_TYPE = {
  REVERSE: 1,
  FORWARD: 2,
}

export const USER_ROLE = {
  SUPPLIER : 1,
  BUYER : 2,
  ADMIN : 3,
  ADMIN_BUYER : 3,
  ADMIN_SUPPLIER : 4
}

export const AUCTION_EVENTS = {
  STATE : 'AUCTION_STATE',
  TIME : 'AUCTION_TIME_EXTENSION'
}

export const ACKNOWLEDGEMENT = {
  SUCCESS: 1,
  ERROR: 2
}

export const ACTION_ROLES = {
  AUCTIONEER: 1,
  BIDDER: 2
}

export const AUTHORITY = {
  AUCTION_CREATOR: 'AUCTION_CREATOR',
  AUCTION_BIDDER: 'AUCTION_BIDDER',
} as const;

export const QUOTA_LEVEL = {
  USER: '2',
  TENANT: '1'
}

export const PRICE_LEVEL = {
  AUCTION : 1,
  ITEM : 2
}

export const BID_LEVEL ={
  ITEM : 2,
  AUCTION : 1
}

export const RANK_BASED_ON = {
  GROSS_TOTAL : 1,
  PER_ITEM : 2
}

export const ROLE_LABEL = {
  SUPPLIER : 'Supplier',
  BUYER : 'Buyer',
  ADMIN : 'Admin',
  ADMIN_BUYER: 'AdminBuyer',
  ADMIN_SUPPLIER: 'AdminSupplier'
}

export const TENANTS = {
  MOPANI: 'TEN-MOP-M99Y'
}
